import _ from 'lodash';
import $ from 'jquery';

global.launchLegacyDialog = function (dialogType, selectedItems, workingFolder, fileId, gridData, user, originWindow) {

	const openerWindow = originWindow || window;

	var w = window.screen.availWidth;
	var h = window.screen.availHeight;
	w = (w - 420) / 2;
	h = (h - 440) / 2;
	var selectedItemsArray = [];

	var windowOptions = 'frame=true;resizable=yes,width=420,height=430,top=' + h + ',left=' + w;

	var selectedArray = [];

	if (dialogType !== 'autoimport') {
	    if (_.find(selectedItems, 'ID')) {
	        selectedArray = selectedItems;
	    } else {
			if(gridData) {
				_.each(selectedItems, function(item) {

					var wtObject = _.find(gridData, function(ds) { return ds.ID === item; });

					var selected = {
						ID: wtObject.ID,
						Status: wtObject.Status ? wtObject.Status.toLowerCase() : '',
						Activity: wtObject.Activity ? wtObject.Activity.toLowerCase() : '',
						CheckedOutBy: user
					};

					selectedArray.push(selected);
				});
			}
	    }

	    if (dialogType === 'checkout') {
	        _.each(selectedArray, function(o) {
	            if (o.Status.toLowerCase() === 'normal') { selectedItemsArray.push(o.ID); }
	        });
	    } else if (dialogType === 'checkin' || dialogType === 'advancedcheckin') {
	        _.each(selectedArray, function(o) {
	            if (o.Status.toLowerCase() === 'checked out' && o.CheckedOutBy === user) { selectedItemsArray.push(o.ID); }
	        });
	    } else {
	        _.each(selectedArray, function(o) {
	            selectedItemsArray.push(o.ID);
	        });
	    }

	    var selectedItemsColon = selectedItemsArray.toString().replace(new RegExp(",", "g"), ':');
	    var selectedItemsSemiColon = selectedItemsArray.toString().replace(new RegExp(",", "g"), ';');
	    selectedItemsArray.length = 0;

	    var isMulti = selectedItemsColon.indexOf(':') !== -1 ? true : false;
	}

	const clearLegacyForm = () => {
		$('#AddFile').val('');
		$('#FileId').val('');
		$('#legacy-form').attr('target', 'LegacyDialog');
	}

	switch (dialogType) {
		// case 'workflow':
		// 	console.log("launchLegacyDialog", selectedItemsSemiColon);
		// 	if (isMulti) {
		// 		clearLegacyForm();
		// 		$('#legacy-form').attr('action', 'legacy/workflowrequest.aspx');
		// 		$('#AddFile').val(selectedItemsSemiColon);
		// 		window.open('/legacy/blank.aspx', "LegacyDialog", windowOptions);
		// 		document.forms["legacy-form"].submit();
		// 	} else {
		// 	    window.open('legacy/workflowrequest.aspx?Folder=' + workingFolder + '&AddFile=' + encodeURIComponent(selectedItemsColon), "workflow", windowOptions);
		// 	}
		// 	break;
		// case 'task':
		// 		window.open('legacy/processselect.aspx?FileID=' + encodeURIComponent(selectedItemsColon), "task", windowOptions);
		// 	break;
		// case 'message':
		// 	if (isMulti) {
		// 		clearLegacyForm();
		// 		$('#legacy-form').attr('action', 'legacy/messagenew.aspx');
		// 		$('#AddFile').val(selectedItemsSemiColon);
		// 		window.open('/legacy/blank.aspx', "LegacyDialog", windowOptions);
		// 		document.forms["legacy-form"].submit();
		// 	} else {
		// 		window.open('legacy/messagenew.aspx?AddFile=' + encodeURIComponent(selectedItemsColon), "message", "frame:true" + windowOptions);
		// 	}
		// 	break;
		// case 'checkin':
		// case 'checkin-vh':
		// case 'project-checkin':
		// case 'project-checkin-previous':

		// 	let q = '';
		// 	if (dialogType === 'checkin-vh') {
		// 		q = `?objectId=${selectedItems[0].ID}&version=${selectedItems[0].Version}&minor=${selectedItems[0].Minor}`
		// 	}

		// 	let action = `/legacy/checkinDialogMulti.aspx${q}`;

		// 	if (dialogType === 'project-checkin' || dialogType === 'project-checkin-previous') {
		// 		action += `?P=1`
		// 	}

		// 	if (dialogType === 'project-checkin-previous') {
		// 		action += `&PV=1&version=${selectedItems[0].Version}&minor=${selectedItems[0].Minor}`
		// 	}

		// 	if (window.chrome?.webview) {
		// 		var fileService = window.angular.element('#container').injector().get('File');
		// 		fileService.getWorkingPaths(selectedItemsSemiColon.split(';')).then(res => {

		// 			const pathCheckCallback = (fileList) => {

		// 				const badList = _.filter(fileList, (o) => !o.existsLocally)

		// 				if (badList.length > 0) {

		// 					let alertMessage = 'The following files were not found and will not be included in the check in:\n\r'

		// 					badList.forEach((badFile) => {
		// 						console.log(badFile.fileName)
		// 						alertMessage += `${badFile.fileName}\n`
		// 					})

		// 					alert(alertMessage)
		// 				}
		// 				else {

		// 					const formData = fileList.map(item => item.objectId).join(';');

		// 					$('#legacy-form').attr('action', action);
		// 					$('#legacy-form').attr('target', 'LegacyCheckinDialog');
		// 					$('#FileId').val(formData);

		// 					let winder = openerWindow.open('/legacy/blank.aspx', "LegacyCheckinDialog", windowOptions);
		// 					winder.name = "LegacyCheckinDialog";

		// 					document.forms["legacy-form"].submit();
		// 				}
		// 			}

		// 			window.chrome.webview.addEventListener('message', (event) => pathCheckCallback(JSON.parse(event.data)), { once: true });

		// 			window.chrome.webview.postMessage({ action: 'checkPaths', payload: res });
		// 		})
		// 	}
		// 	else {

		// 		$('#legacy-form').attr('action', action);
		// 		$('#legacy-form').attr('target', 'LegacyCheckinDialog');
		// 		$('#FileId').val(selectedItemsSemiColon);

		// 		openerWindow.open('/legacy/blank.aspx', "LegacyCheckinDialog", windowOptions);

		// 		document.forms["legacy-form"].submit();
		// 	}
		// 	break;
		case 'relatedmessages':
			var dialogHeight = window.screen.availHeight < 600 ? window.screen.availHeight - 150 : 550;
			window.open('legacy/relatedmessages.aspx?FileID=' + encodeURIComponent(selectedItemsColon), "relatedMessages", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=555,height=' + (dialogHeight + 5) + ',top=' + h + ',left=' + w);
			break;
		case 'newfile':
		    window.open('legacy/newdocument.aspx?SelectedFolder=' + workingFolder, "newFile", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=455,height=585,top=' + h + ',left=' + w);
			break;
		case 'newfolder':
			window.open('legacy/newfolderdialog.aspx?ParentFolder=' + workingFolder, "newFolder", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=466,height=200,top=' + h + ',left=' + w);
			break;
	    case 'project-newfolder':
	        window.open('legacy/newfolderdialog.aspx?CallingApp=ProjectsView&ParentFolder=' + workingFolder, "pNewFolder", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=325,height=160,top=' + h + ',left=' + w);
	        break;
		case 'newstructure':
		    window.open('legacy/NewFolderStructure.aspx?ParentFolder=' + workingFolder, "newStructure", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=500,height=500,top=' + h + ',left=' + w);
			break;
		case 'documentlog':
			window.open('legacy/DocumentLog.aspx?FileID=' + encodeURIComponent(selectedItemsColon), "documentLog", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=960,height=250,top=' + h + ',left=' + w);
			break;
		case 'bravahtml':
			selectedItems.forEach(item => {
				if (item.Version) {
					window.open(`/brava/viewer.aspx?fileid=${encodeURIComponent(item.ID)}&version=${item.Version}&minor=${item.Minor}`, "", 'resizable=yes,menubar=no,toolbar=no,status=yes,scrollbars=yes,location=no,menubar=no');
				} else {
					window.open(`/brava/viewer.aspx?fileid=${encodeURIComponent(item.ID)}`, "", 'resizable=yes,menubar=no,toolbar=no,status=yes,scrollbars=yes,location=no,menubar=no');
				}
			})
			break;
		// case 'versionhistory':
		// 	window.open('legacy/versionhist.aspx?FileID=' + encodeURIComponent(selectedItemsColon), "versionHistory", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=960,height=250,top=' + h + ',left=' + w);
		// 	break;
	  //   case 'notes':
	  //       window.open('legacy/docnotes.aspx?FileID=' + encodeURIComponent(selectedItemsColon), "notes", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=530,height=460,top=' + h + ',left=' + w);
		// 	break;
		// case 'updateprofile':

		// 	selectedItems.forEach(item => {
		// 		if (item.Version) {
		// 			window.open(`legacy/updateprofile.aspx?ID=${encodeURIComponent(selectedItemsColon)}&versionid=${item.Version}&minor=${item.Minor}`, "updateProfile", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=420,height=315,top=' + h + ',left=' + w);
		// 		} else {
		// 			window.open('legacy/updateprofile.aspx?ID=' + encodeURIComponent(selectedItemsColon), "updateProfile", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=420,height=315,top=' + h + ',left=' + w);
		// 		}
		// 	})
		// 	break;
	    case 'delete':
			if (isMulti) {
						clearLegacyForm();
	            $('#legacy-form').attr('action', 'legacy/deletedialog.aspx');
	            $('#FileId').val(selectedItemsSemiColon);
	            window.open('/legacy/blank.aspx', "LegacyDialog", windowOptions);
	            document.forms["legacy-form"].submit();
	        } else {
	            window.open('legacy/deletedialog.aspx?FileID=' + encodeURIComponent(selectedItemsColon), "delete", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=335,height=415,top=' + h + ',left=' + w);
	        }
			break;
		case 'restore':
			clearLegacyForm();
	        $('#legacy-form').attr('action', 'legacy/recyclebinaction.aspx?action=RF');
	        $('#FileId').val(selectedItemsSemiColon);
	        window.open('/legacy/blank.aspx', "LegacyDialog", windowOptions);
	        document.forms["legacy-form"].submit();
	        break;
		case 'permanentdelete':
			clearLegacyForm();
	        $('#legacy-form').attr('action', 'legacy/recyclebinaction.aspx?action=DF');
	        $('#FileId').val(selectedItemsSemiColon);
	        window.open('/legacy/blank.aspx', "LegacyDialog", windowOptions);
	        document.forms["legacy-form"].submit();
	        break;
	    case 'restoreBin':
	        window.open('legacy/recyclebinaction.aspx?FileID=RestoreRecycleBin', "restoreBin", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=335,height=415,top=' + h + ',left=' + w);
	        break;
	    case 'emptyBin':
	        window.open('legacy/recyclebinaction.aspx?FileID=EmptyRecycleBin', "emptyBin", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=335,height=415,top=' + h + ',left=' + w);
	        break;
	    case 'project-edit':
	        window.open('legacy/projecteditor.aspx?ID=' + encodeURIComponent(selectedItemsColon), "pEdit", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=800,height=500,top=' + h + ',left=' + w);
	        break;
	    case 'project-folder-edit':
	        var id = workingFolder ? workingFolder : selectedItemsColon;
	        window.open('legacy/projecteditor.aspx?ID=' + encodeURIComponent(id), "pFolderEdit", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=800,height=500,top=' + h + ',left=' + w);
	        break;
	    case 'project-new':
	        window.open('legacy/projecteditor.aspx?Parent=' + encodeURIComponent(workingFolder), "pNew", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=800,height=500,top=' + h + ',left=' + w);
	        break;
	    case 'project-addfile':
	        window.open('legacy/commondialog.aspx?P=1&CurrentFolder=Documents&DialogMode=Open&SourceTable=Objects', "pAddFile", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=500,height=335,top=' + h + ',left=' + w);
					break;
		case 'project-addfile-editor':
				window.open('legacy/commondialog.aspx?P=1&CurrentFolder=Documents&DialogMode=Open&SourceTable=Objects&openerName=editor', "pAddFile", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=500,height=335,top=' + h + ',left=' + w);
				break;
	    case 'select-path':
	        window.open('legacy/commonsearchdialog.aspx?CurrentFolder=Documents&DialogMode=SearchFolders&SourceTable=Objects', "selectPath", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=500,height=335,top=' + h + ',left=' + w);
	        break;
	    case 'save-search':
	        window.open('legacy/savesearch.aspx', "saveSearch", 'resizable=yes,menubar=no,toolbar=no,status=no,scrollbars=1,location=no,menubar=no,width=500,height=360,top=' + h + ',left=' + w);
			break;
		default:
			break;
	}
}